import { deleteDataConnection } from "actions/Utilities/DataConnection";
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { dataConnectionReFetching } from "../atoms/atoms";

export default function useDeleteDataConnection() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    dataConnectionReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteDataConnection(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Data Connection failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Data Connection Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Data Connection Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Data Connection failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Data Connection not found":
              toast.fire(
                "Disabling Data Connection failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Data Connection failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Data Connection failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
